import { render } from "./DevolucionesList.vue?vue&type=template&id=6ab8e54a&scoped=true"
import script from "./DevolucionesList.vue?vue&type=script&lang=js"
export * from "./DevolucionesList.vue?vue&type=script&lang=js"

import "./DevolucionesList.vue?vue&type=style&index=0&id=6ab8e54a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab8e54a"]])

export default __exports__